import { portfolio } from "../data/portfolio";

export function Footer() {
  const { identity } = portfolio;
  return (
    <footer className="m3-footer">
      <div className="md-container m3-footer__row">
        <div className="md-body-m">
          © {new Date().getFullYear()} {identity.name}. 
        </div>
        <div className="md-chip-group">
          <a className="md-chip md-chip--assist" href={"mailto:" + identity.email}>
            <span className="material-symbols-rounded icon-20">mail</span>
            Email
          </a>
          <a className="md-chip md-chip--assist" href={identity.links.github} target="_blank" rel="noreferrer">
            <span className="material-symbols-rounded icon-20">code</span>
            GitHub
          </a>
          <a className="md-chip md-chip--assist" href={identity.links.linkedin} target="_blank" rel="noreferrer">
            <span className="material-symbols-rounded icon-20">groups</span>
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
}
